module.exports = __webpack_public_path__ + "img/banner_headphone.ff2edc17.png";